<template>
  <!-- 消费流水 -->
  <div class="expenseWater">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['订单管理',$route.meta.title]">
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-date-picker
          type="date"
          format='yyyy-MM-dd'
          value-format='yyyy-MM-dd'
          clearable
          v-model="searchForm.start"
          style="width:200px;margin-right:5px"
          placeholder="选择开始日期">
        </el-date-picker>
        <el-date-picker
          type="date"
          format='yyyy-MM-dd'
          value-format='yyyy-MM-dd'
          clearable
          v-model="searchForm.end"
          style="width:200px;margin-right:5px"
          placeholder="选择结束日期">
        </el-date-picker>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入名称搜索" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        label="序号"
        align="center"
        width="50">
        <template slot-scope="scope">
          <span>{{(currPage - 1) * pageSize + scope.$index + 1}}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="OrderNo"
        show-overflow-tooltip
        label="订单号">
      </el-table-column>
      <el-table-column
        prop="businessName"
        align="center"
        show-overflow-tooltip
        label="用户名">
      </el-table-column>
      <el-table-column
        prop="telphone"
        label="联系方式"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="PayType"
        label="支付方式"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="Money"
        label="金额"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="Platform"
        label="设备"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip>
        <template slot-scope="scope">
            <el-tag v-if="scope.row.status === '1'" type="success">成功</el-tag>
            <el-tag v-else type="waring">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="Remake"
        label="流水类型"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="Addtime"
        label="消费时间"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
  </div>
</template>

<script>

export default {
  name: 'expenseWater',
  data() {
    return {
      // {
      //   orderNum:"订单号",
      //   userName:"用户名",
      //   contact:"联系方式",
      //   payMode:"支付方式",
      //   money:"金额",
      //   device:"设备",
      //   status:"状态",
      //   waterType:"流水类型",
      //   time:"消费时间"
      // }
      tableData:[],
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      /**搜索表单 */
      //开始时间 结束时间 模糊查询
      searchForm:{
        start:"",
        end:"",
        name:""
      }
    }
  },
  components: {
    
  },
  mounted(){
    this.getTableData()
  },
  methods:{
    search(){
      this.getTableData(1)
    },
    /**获取表格 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      let data = {
        type: "PC_UserMoneyList",
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "PC_Recharge";//存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method:"post",
        url: "rechargeorder/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
        dataType:"json"
      }).then((res) => {
        this.tableData = []
        if (res.flag == 0) {
          this.tableData = res.data
          this.allPage = res.recordCount
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
  }
}
</script>

<style scoped>
.expenseWater{
  width: 100%;
  height: 100%;
}
</style>
